import React from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { COLOR_PALETTE } from 'constants/ui';

import { getTitleContainerIconStyles } from './TitleIcon.styles';

const TitleIcon = ({
  icon: Icon,
  iconSize = IconSize[18],
  containerColor = COLOR_PALETTE.BLUE[2],
  iconColor = COLOR_PALETTE.BLUE[7],
}) => (
  <Box className="title-icon" sx={getTitleContainerIconStyles({ containerColor, iconColor })}>
    <Icon size={iconSize} />
  </Box>
);

TitleIcon.propTypes = {
  icon: PropTypes.elementType.isRequired,
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  containerColor: PropTypes.string,
  iconColor: PropTypes.string,
};

export default TitleIcon;
